import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import lessThenIcon from "../Image/Lessthen-icon.png";
import equalIcon from "../Image/equalto-icon.png";
import graterThenIcon from "../Image/greterthen-icon.png";
import plusIcon from "../Image/plus-icon.png";
import d1 from "../Image/dice1.png";
import d2 from "../Image/dice2.png";
import d3 from "../Image/dice3.png";
import d4 from "../Image/dice4.png";
import d5 from "../Image/dice5.png";
import d6 from "../Image/dice6.png";
import winner from "../Image/gameWinImg.png";
import looser from "../Image/gameLoseImg.png";
import { useForm } from "react-hook-form";
import bitcoin from "../Image/bitcoin.png";

function Dicegame({ setOpenLogin, isAuth }) {
  const diceImages = [null, d1, d2, d3, d4, d5, d6];
  const [dice, setDice] = useState({ one: 5, two: 6 });
  const [isRolling, setIsRolling] = useState(false);
  const [selectedBet, setSelectedBet] = useState();
  const [gameResult, setGameResult] = useState(null);
  const [tableData, setTableData] = useState([]);
  const { wallet, setWallet } = useAuth();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("gameData")) || [];
    setTableData(storedData);
    const loadWallet = () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

      setWallet(currentUser?.wallet ? parseFloat(currentUser.wallet) : 0);
    };

    loadWallet();
  }, [isAuth, setWallet]);

  const rollDice = (data) => {
    const betAmount = parseFloat(data.amount);
    if (!isAuth) {
      setOpenLogin(true);
      return;
    }

    if (!selectedBet) {
      toast.error("Please Select a Bet");
      return;
    }

    if (betAmount <= 0) {
      toast.error("Enter amount greater than 0");
      return;
    }

    if (Number(data.amount) > wallet) {
      toast.error("Insufficient Wallet Balance");
      return;
    }

    if (isRolling) return;

    setIsRolling(true);
    setGameResult(null);

    setTimeout(() => {
      const val1 = Math.floor(Math.random() * 6) + 1;
      const val2 = Math.floor(Math.random() * 6) + 1;
      const sum = val1 + val2;

      setDice({ one: val1, two: val2 });
      setIsRolling(false);

      let result = "";
      let finalWallet = wallet;

      if (sum < 7) result = "less";
      else if (sum === 7) result = "equal";
      else result = "greater";

      let finalResult = "";
      if (selectedBet === result) {
        finalResult = "winner";
        setGameResult("winner");
        finalWallet = wallet + betAmount * 2;
      } else {
        finalResult = "looser";
        setGameResult("looser");
        finalWallet = wallet - betAmount;
      }
      setWallet(finalWallet);
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      currentUser.wallet = finalWallet;
      localStorage.setItem("currentUser", JSON.stringify(currentUser));

      const users = JSON.parse(localStorage.getItem("user")) || [];
      const updatedUsers = users.map((user) => {
        if (user.email === currentUser.email) {
          return { ...user, wallet: finalWallet };
        }

        return user;
      });
      
      localStorage.setItem("user", JSON.stringify(updatedUsers));

      localStorage.setItem(
        "currentUser",
        JSON.stringify({ ...currentUser, wallet: finalWallet }),
      );

      const newGameData = {
        email: currentUser?.email || "Guest",
        selectedBet: selectedBet,
        diceTotal: sum,
        betAmount: betAmount,
        winAmount: finalResult === "winner" ? betAmount * 2 : 0,
        result: finalResult,
      };

      console.log(newGameData);

      setTableData((prev) => {
        const updatedData = [...prev, newGameData];
        localStorage.setItem("gameData", JSON.stringify(updatedData));
        return updatedData;
      });
      reset();
    }, 1000);
  };

  return (
    <div className="dicegame-section">
      <div className="container">
        <div className="dicegame-wrapper">
          {gameResult && (
            <div className="result-popup">
              <img
                src={gameResult === "winner" ? winner : looser}
                alt={gameResult}
                className="result-status-img"
              />
              <button onClick={() => setGameResult(null)}>Close</button>
            </div>
          )}
          <form
            onSubmit={
              isAuth
                ? handleSubmit(rollDice)
                : (e) => {
                    e.preventDefault();
                    setOpenLogin(true);
                  }
            }
          >
            <div className="dicegame-wrapper-inner">
              <div className="d-flex align-items-center justify-content-center gap-2 dicegame-card">
                <img
                  src={lessThenIcon}
                  alt="Less"
                  className={selectedBet === "less" ? "active-bet" : ""}
                  onClick={() => setSelectedBet("less")}
                />
                <img
                  src={equalIcon}
                  alt="equal"
                  className={selectedBet === "equal" ? "active-bet" : ""}
                  onClick={() => setSelectedBet("equal")}
                />

                <img
                  src={graterThenIcon}
                  alt="grater"
                  className={selectedBet === "greater" ? "active-bet" : ""}
                  onClick={() => setSelectedBet("greater")}
                />
              </div>

              <div className="amount-field mt-3">
                <div
                  className="bet-input-wrapper d-flex align-items-center"
                  style={{ backgroundColor: "#092a69" }}
                >
                  <div className="d-flex align-items-center">
                    <img src={bitcoin} alt="bitcoin" height={24} />
                  </div>

                  <input
                    type="number"
                    step="any"
                    placeholder="Enter Your Bet Amount"
                    className="amount-input"
                    {...register("amount", {
                      required: "Amount is required",
                      validate: (value) =>
                        parseFloat(value) > 0 ||
                        "Amount must be greater than 0",
                    })}
                  />
                </div>

                {errors.amount && (
                  <p className="error-text">{errors.amount.message}</p>
                )}
              </div>

              <button type="submit" className="dice-btn" disabled={isRolling}>
                {!isAuth
                  ? "LOGIN TO PLAY"
                  : isRolling
                    ? "ROLLING..."
                    : "ROLL DICE"}
              </button>
            </div>
          </form>

          <div className="dicegame-bg">
            <div className="d-flex align-items-center dicegame-inner">
              <img
                src={diceImages[dice.one]}
                className={`dice-img ${isRolling ? "dice-rotate" : ""}`}
                alt="Dice 1"
              />

              <img src={plusIcon} alt="Icon" />

              <img
                src={diceImages[dice.two]}
                className={`dice-img ${isRolling ? "dice-rotate" : ""}`}
                alt="Dice 2"
              />
            </div>
          </div>
        </div>

        <div className="mt-4 gametable-responsive-wrapper">
          <table className="game-table">
            <thead>
              <tr>
                <th>Player Email</th>
                <th>Selected Bets</th>
                <th>Dice Total</th>
                <th>Bet Amount</th>
                <th>Win Amount</th>
                <th>Result</th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.email}</td>
                    <td>{item.selectedBet}</td>
                    <td>{item.diceTotal}</td>
                    <td>{item.betAmount}</td>
                    <td>{item.winAmount ? item.winAmount : "-"}</td>
                    <td>{item.result === "winner" ? "Winner" : "Looser"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No Game Played Yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Dicegame;
